import { getHumanReadableTimeDifference } from 'utils/getHumanReadableTimeDifference';
export function getHumanReadableExpiration(now, replyWindowExpiresOn) {
    if (!replyWindowExpiresOn)
        return '';
    if (now >= replyWindowExpiresOn.getTime())
        return 'Reply window closed';
    return `Reply window closes in ${getHumanReadableTimeDifference(new Date(now), replyWindowExpiresOn)}`;
}
